import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BasicValue from "./BasicValue.js";
import FieldName from "./FieldName.js";
import { makeStyles } from "../../util/tss-react/index.js";
const useStyles = makeStyles()({
    field: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});
export default function UriField({ value, prefix, name, }) {
    const { classes } = useStyles();
    const { uri, baseUri = '' } = value;
    let href;
    try {
        href = new URL(uri, baseUri).href;
    }
    catch (e) {
        href = uri;
    }
    return (_jsxs("div", { className: classes.field, children: [_jsx(FieldName, { prefix: prefix, name: name }), _jsx(BasicValue, { value: href })] }));
}
